import {
    keyboard
} from "../../../../diagram/models/keycodes.enum";
import { LABEL_PROPERTIES } from "../cell/grid-cell.config";
import { GridSizedViewUtils } from "../../utils/GridSizeViewUtils";
import { CellRetrievalUtils } from "../../utils/CellRetrievalUtils";

export class LabelCell {
    payload;

    labelHandler = null;

    labelProperties = LABEL_PROPERTIES;

    elementSavedEnter = null;

    cellRetrievalUtils = new CellRetrievalUtils();

    constructor(payload, labelHandler) {
        this.payload = payload;
        this.labelHandler = labelHandler;
    }

    editLabel(mousePos, grid, cellWidth) {
        let pluginLabel = false;
        for (let i = 0; i < this.labelHandler.labelsList.length; i++) {
            const position = this.labelHandler.labelsList[i].labelPosition;
            const labelWidth = mousePos.fabricDiagramCtx.ctx.measureText(this.labelHandler.labelsList[i].label);
            let minX; let maxX; let minY; let
                maxY;

            minX = position.x - labelWidth.width / 2 - this.labelHandler.labelProperties.paddingLabelX - (this.labelHandler.labelProperties.dragPointLabelRadius * 2);
            maxX = position.x + labelWidth.width / 2 + this.labelHandler.labelProperties.paddingLabelX;
            minY = position.y - parseInt(this.labelHandler.labelProperties.fontLabel);
            maxY = position.y + parseInt(this.labelHandler.labelProperties.fontLabel);

            if (minX < mousePos.x && mousePos.x < maxX
                && minY < mousePos.y && mousePos.y < maxY) {
                this.generateTexteria(position, mousePos, this.labelHandler.labelsList[i], grid, false, false);
                pluginLabel = true;
                break;
            }
        }

        if (!pluginLabel) {
            for (let i = 0; i < this.labelHandler.connectorsList.length; i++) {
                const { labelWidth } = this.labelHandler.getLabelWidth(mousePos.fabricDiagramCtx.ctx, this.labelHandler.connectorsList[i].label.value);
                let minX;
                let maxX;
                let minY;
                let maxY;

                minX = this.labelHandler.connectorsList[i].label.x - labelWidth.width / 2 - this.labelHandler.labelProperties.paddingLabelX - (this.labelHandler.labelProperties.dragPointLabelRadius * 2);
                maxX = this.labelHandler.connectorsList[i].label.x + labelWidth.width / 2 + this.labelHandler.labelProperties.paddingLabelX;
                minY = this.labelHandler.connectorsList[i].label.y - parseInt(this.labelHandler.labelProperties.fontLabel);
                maxY = this.labelHandler.connectorsList[i].label.y + parseInt(this.labelHandler.labelProperties.fontLabel);

                if (minX < mousePos.x && mousePos.x < maxX
                    && minY < mousePos.y && mousePos.y < maxY) {
                    this.generateTexteria(this.labelHandler.connectorsList[i].label, mousePos, this.labelHandler.connectorsList[i], grid, true, false);
                    break;
                }
            }
        }
    }

    editConnectorlabel(data, payload) {
        this.generateTexteria(null, payload, data, null, true, true);
    }

    generateTexteria(position, mousePos, elem, grid, isConnector, newLabel) {
        let widthOfPluginText; let labelwidth; let inputPosX; let inputPosY; let
            texteriaValue;

        if (isConnector) {
            if (newLabel) {
                let connectorObject;
                inputPosX = elem.instance.midPoint.x - mousePos.fabricDiagramCtx.diagramCamera.scrollbars.left
                    + (mousePos.event.clientX - mousePos.event.layerX + this.labelProperties.paddingLabelY);
                inputPosY = elem.instance.midPoint.y - mousePos.fabricDiagramCtx.diagramCamera.scrollbars.top + (mousePos.event.clientY - mousePos.event.layerY)
                    - elem.instance.midPointRadius * 2;
                connectorObject = this.labelHandler.getConnectorLabel(elem.instance.uuid);
                texteriaValue = connectorObject && connectorObject.label && connectorObject.label.value ? connectorObject.label.value : "";
                this.showTexteria(inputPosX, inputPosY, texteriaValue, elem, grid, isConnector, newLabel);
            } else {
                widthOfPluginText = this.labelHandler.getLabelWidth(mousePos.fabricDiagramCtx.ctx, elem.label.value).labelWidth;

                labelwidth = widthOfPluginText.width / 2 + (this.labelProperties.paddingLabelX / 2)
                    + (this.labelProperties.dragPointLabelRadius * 2);

                inputPosX = position.x - labelwidth - mousePos.fabricDiagramCtx.diagramCamera.scrollbars.left
                    + (mousePos.event.clientX - mousePos.event.layerX + this.labelProperties.paddingLabelY);
                inputPosY = position.y - mousePos.fabricDiagramCtx.diagramCamera.scrollbars.top + (mousePos.event.clientY - mousePos.event.layerY);
                texteriaValue = elem.label.value;
                this.showTexteria(inputPosX, inputPosY, texteriaValue, elem, grid, isConnector, false);
            }
        } else {
            widthOfPluginText = this.labelHandler.getLabelWidth(mousePos.fabricDiagramCtx.ctx, elem.label).labelWidth;

            labelwidth = widthOfPluginText.width / 2 + (this.labelProperties.paddingLabelX / 2)
                + (this.labelProperties.dragPointLabelRadius * 2);

            inputPosX = position.x - labelwidth - mousePos.fabricDiagramCtx.diagramCamera.scrollbars.left
                + (mousePos.event.clientX - mousePos.event.layerX + this.labelProperties.paddingLabelY);
            inputPosY = position.y - mousePos.fabricDiagramCtx.diagramCamera.scrollbars.top
                + (mousePos.event.clientY - mousePos.event.layerY);
            texteriaValue = elem.label;
            this.showTexteria(inputPosX, inputPosY, texteriaValue, elem, grid, isConnector, newLabel);
        }
    }

    showTexteria(inputPosX, inputPosY, texteriaValue, elem, grid, isConnector, newLabel) {
        const textarea = document.createElement("textarea");

        textarea.id = "customLabelId";
        textarea.style.position = "fixed";
        textarea.maxLength = "100";
        textarea.cols = "27";
        textarea.rows = "1";
        textarea.style.left = `${inputPosX}px`;
        textarea.style.top = `${inputPosY}px`;
        textarea.style["border-radius"] = "3px";
        textarea.style.resize = "none";
        textarea.style.maxHeight = "150px";
        textarea.style.overflow = "hidden";
        textarea.style["font-size"] = `${this.labelProperties.fontLabelEditMode}px`;
        textarea.value = texteriaValue;
        if (texteriaValue) textarea.select();

        textarea.addEventListener("keydown", this.autosizeLabel.bind(this, elem, grid, isConnector, newLabel));
        textarea.addEventListener("blur", this.labelLoseFocus.bind(this, elem, grid, isConnector, newLabel));

        document.body.appendChild(textarea);

        this.textereaProps(textarea);
        textarea.focus();
    }

    autosizeLabel(elem, grid, isConnector, newLabel, e) {
        if (e && e.keyCode === keyboard.ENTER && e.target.value) {
            this.saveOnEnter(elem, grid, isConnector, newLabel, e);
        } else {
            setTimeout(() => {
                this.textereaProps(e.target);
            }, 0);
        }
    }

    textereaProps(item) {
        item.style.height = "auto";
        item.style["padding-top"] = "0";
        item.style["padding-bottom"] = "0";
        item.style.height = `${item.scrollHeight}px`;
        item.style["overflow-y"] = (item.scrollHeight > 150) ? "scroll" : "hidden";
    }

    saveOnEnter(elem, grid, isConnector, newLabel, e) {
        this.saveNewLabel(elem, grid, isConnector, newLabel, e);
        e.target.removeEventListener("keydown", this.saveOnEnter);

        const element = document.getElementById("customLabelId");
        if (element) {
            this.elementSavedEnter = true;
            element.remove();
        }
    }

    labelLoseFocus(elem, grid, isConnector, newLabel, e) {
        e.target.removeEventListener("blur", this.labelLoseFocus);
        const element = document.getElementById("customLabelId");
        if (element && !this.elementSavedEnter) {
            this.saveNewLabel(elem, grid, isConnector, newLabel, e);
            element.remove();
        } else {
            this.elementSavedEnter = false;
        }
    }

    saveNewLabel(elem, grid, isConnector, newLabel, e) {
        if (isConnector) {
            // add / update connector label
            this.labelHandler.addConnectorLabel(newLabel, e, elem, grid);
        } else {
            // update plugin label
            const gridSizeUtils = new GridSizedViewUtils();
            this.labelHandler.setNewLabel(elem.uuidCell, e.target.value);
            const newCellPos = gridSizeUtils.getPermanentGridCellPos(elem.cellStartPoint, grid);
            const cell = this.cellRetrievalUtils.getCell(newCellPos, grid);
            cell.draw();
        }
    }
}
